import { render, staticRenderFns } from "./group.vue?vue&type=template&id=c148389a&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=c148389a&prod&scoped=true&lang=css"
import style1 from "./group.vue?vue&type=style&index=1&id=c148389a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c148389a",
  null
  
)

export default component.exports